import { render } from "./AddPlaceholder.vue?vue&type=template&id=38611d6e"
import script from "./AddPlaceholder.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AddPlaceholder.vue?vue&type=script&charset=utf-8&lang=js"

import "./AddPlaceholder.vue?vue&type=style&index=0&id=38611d6e&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__